import { getSpotimoodBaseUrl } from '~/helpers/api/getBaseUrl'
import { defineSpotimoodFetch, getFetchWithDefaults } from '~/helpers/fetch'

export function useProvideSpotimoodFetch() {
  const runtimeConfig = useRuntimeConfig()
  const cookieRequestHeaders = useRequestHeaders(['cookie'])

  const spotimoodFetch = defineSpotimoodFetch(
    getFetchWithDefaults(
      {
        baseURL: getSpotimoodBaseUrl(runtimeConfig),
        credentials: 'omit',
      },
      cookieRequestHeaders,
    ),
  )

  return {
    spotimoodFetch,
  }
}
